<template>
  <div class="mainContaner full_w" style="background-color: #f5f5f5;height: 49rem">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <van-tabs :sticky="true" v-model="active" :isFixed="true" :line-width="32" animated :swipeable="true" title-active-color="#EB84AB" @change="changeAction" @scroll="scorllAction">
        <van-tab title="好券推荐" >
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh(1)">
            <div class="full_w" style="padding-bottom: 1rem;">
              <div class="coupon_item" :class="code.isHave=='N'&&code.residueNum!=0?'':'coupon_item_isHave'" v-for="(code,index) in drawProductPromoList" @key="index">
                <img style="position: absolute;width: 22.5rem" :src="code.isHave=='N' &&code.residueNum!=0?require('@/images/bj_coupon2@3x.png'):require('@/images/bj_coupon_Have received@3x.png')">
                <div style="position: absolute;width: 22rem;padding-top: 0.5rem">
                  <div class="fl" style="width: 2rem;height: 3.3rem">
                    <p class="clear_style zt12 white" style="padding-left: 0.2rem;margin:0 auto;writing-mode: vertical-lr;width: 2rem;height: 5.5rem" :class="code.description.length > 7?'':'coupon_item_width'">{{code.description}}</p>
                  </div>
                  <div class="fl" style="padding-left: 1rem;margin-top: -0.6rem;width: 12rem">
                    <div>
                      <div class="clear_style zt48 blod tc fl wpurple" style="padding-left: 1rem;width: 7rem">{{getPromoValue(code)}}</div>
                      <div class="fl" style="padding-top: 0.7rem;margin-left: 0.5rem">
                        <p class="clear_style zt14 blod tc wpurple">{{getPromoType(code.type)}}</p>
                        <span class="zt14 blod wpurple">{{code.type=="discount"?'折':'RMB'}}</span>
                      </div>
                    </div>
                    <p class="clear_style zt10 tc fl full_w">
                      <span class="coupon_item_date wpurple">有效期:{{getPromoDate(code)}}</span>
                    </p>
                    <p class="clear_style zt14 white tc fl full_w" style="line-height: 1rem;height: 1.5rem;;overflow: hidden">{{code.productPromoName}}</p>
                  </div>
                  <button @click="clickAction(code,1)" class="zt12 white fr" style="border: 1px solid white;padding: 0.1rem 0.5rem;border-radius: 1.5rem;margin: 2rem 0.5rem;width: 5rem;">{{getPromoBtnText(code)}}</button>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="K币兑换">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh(2)">
            <div class="full_w" style="padding-bottom: 1rem;">
              <p class="zt14 black" style="padding: 0rem 1rem">您当前的K币为：{{kCoinBalance}}K币</p>
              <div class="coupon_item" v-if="!emptyList" :class="exchangeItem.isHave=='N'&&exchangeItem.residueNum!=0?'':'coupon_item_isHave'" v-for="(exchangeItem,index) in exchangeProductPromoList" :key="index">
                <img style="position: absolute;width: 22.5rem" :src="exchangeItem.isHave=='N' &&exchangeItem.residueNum!=0?require('@/images/bj_coupon2@3x.png'):require('@/images/bj_coupon_Have received@3x.png')">
                <div style="position: absolute;width: 22rem;padding-top: 0.5rem">
                  <div class="fl" style="width: 2rem;height: 3.3rem">
                    <p class="clear_style zt12 white" style="padding-left: 0.2rem;margin:0 auto;writing-mode: vertical-lr;width: 2rem;height: 5.5rem" :class="exchangeItem.description.length > 7?'':'coupon_item_width'">{{exchangeItem.description}}</p>
                  </div>
                  <div class="fl" style="padding-left: 1rem;margin-top: -0.6rem;width: 12rem">
                    <div>
                      <div class="clear_style zt48 blod tc fl wpurple" style="padding-left: 1rem;width: 7rem">{{getPromoValue(exchangeItem)}}</div>
                      <div class="fl" style="padding-top: 0.7rem;margin-left: 0.5rem">
                        <p class="clear_style zt14 blod tc wpurple">{{getPromoType(exchangeItem.type)}}</p>
                        <span class="zt14 blod wpurple">{{exchangeItem.type=="discount"?'折':'RMB'}}</span>
                      </div>
                    </div>
                    <p class="clear_style zt10 tc fl full_w">
                      <span class="coupon_item_date wpurple">有效期:{{getPromoDate(exchangeItem)}}</span>
                    </p>
                    <p class="clear_style zt14 white tc fl full_w" style="line-height: 1rem;height: 1.5rem;;overflow: hidden">{{exchangeItem.productPromoName}}</p>
                  </div>
                  <span class="zt12 white tc fr" style="padding: 0.1rem 0.5rem;margin: 0.5rem 0.5rem;width: 4rem;" :class="exchangeItem.isHave=='N'">{{exchangeItem.points}}K币</span>
                  <button @click="clickAction(exchangeItem,2)" class="zt12 white fr" style="border: 1px solid white;padding: 0.1rem 0.5rem;border-radius: 1.5rem;margin: 0.5rem 0.5rem;width: 5rem;">{{getPromoBtnText(exchangeItem)}}</button>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>


      <div class="cart_content" v-if="emptyList">
        <p class="tc grey zt16" style="padding: 2rem 0">暂无可领取/可兑换的优惠券</p>
        <p class="tc grey zt16">耐心等待活动发布</p>
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId ,shareOnlineUrl,wxUrl} from '@/router/Constant'
  import { getDrawProductPromoList,getExchangeProductPromoList,getProductPromoCode,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie,setMiniProgramShare } from '@/utils/mUtil';
  import {Image,Button,Tab, Tabs } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'promoCenter',
    data() {
      return {
        active:0,
        token:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        showLoading:true,
        viewIndex:0,
        viewSize:20,
        emptyList:false,
        drawProductPromoList:[],
        exchangeProductPromoList:[],
        show: false,
        allLoaded: false,
        isLoading:false,
        kCoinBalance:0,
        authorization: 'Bearer ' + getCookie('authorization'),
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      footerView,
      loading,
      refresh
    },
    methods:{
      async initData() {
        this.getDrawProductPromoList();
      },
      getDrawProductPromoList() {
        getDrawProductPromoList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
          .then(res => {
            console.log("getDrawProductPromoList")
            console.log(res)
            if (res.productPromoCodeList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            this.drawProductPromoList = res.productPromoCodeList

            setMiniProgramShare('畅“玩”HelloKittyPark','',wxUrl+encodeURIComponent(shareOnlineUrl+'promoCenter'))
            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getExchangeProductPromoList() {
        getExchangeProductPromoList({Authorization:this.authorization,externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
          .then(res => {
            console.log("getExchangeProductPromoList")
            console.log(res)
            if (res.productPromoCodeList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            this.exchangeProductPromoList = res.productPromoCodeList
            this.kCoinBalance = res.kCoinBalance
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getProductPromoCode(type,id) {
        console.log('1111' + this.authorization)
        getProductPromoCode({externalLoginKey:getStore('externalLoginKey'),Authorization:this.authorization,productPromoId:id,productStoreId: storeName})
          .then(res => {
            console.log("getProductPromoCode")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast.fail(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
              Toast.success('领取成功');
              if(type==1){
                this.onRefresh(1);
              }else if(type==2){
                this.onRefresh(2);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPromoType(type) {
        var typeName = '';
        switch (type) {
          case 'gift':
            typeName = '礼品券'
            break;
          case 'discount':
            typeName = '折扣券'
            break;
          case 'deduct':
            typeName = '满减券'
            break;
          case 'special':
            typeName = '特价券'
            break;
          default:
            break
        }
        return typeName
      },
      getPromoDate(item) {
        var msg = ""
        if (item.fromDate == null && item.thruDate == null) {
          msg = "不限制时间使用"
        }
        if (item.fromDate == null && item.thruDate != null) {
          msg = "截止到" + item.thruDate | formatDate + "失效"
        }
        if (item.fromDate != null && item.thruDate == null) {
          msg = this.formatDate(item.fromDate) + "后开始使用"
        }
        if (item.fromDate != null && item.thruDate != null) {
          msg = this.formatDate(item.fromDate) + "-" + this.formatDate(item.thruDate)
        }
        return msg
      },
      getPromoBtnText(item) {
        var msg = ""
        if (item.isHave == 'Y') {
          msg = "已领取"
        } else if(item.isHave == 'N' && item.residueNum != 0) {
          msg = "立即领取"
        } else {
          msg = "已领完"
        }
        return msg
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return y + '.' + MM + '.' + d
        }else{
          return ''
        }
      },
      changeAction(name,title) {
        this.resetParam();
        switch (title) {
          case '好券推荐':
            this.getDrawProductPromoList();
            break;
          case 'K币兑换':
            this.getExchangeProductPromoList();
            break;
          default:
            break
        }
      },
      scorllAction(scrollTop) {
        console.log(scrollTop)
        if (scrollTop.scrollTop > 0) {
          this.$refs.navView.style.display = 'none';
        } else {
          if (this.$refs.navView) {
            this.$refs.navView.style.display = 'block';
          }
        }
      },
      clickAction(code,tab) {
        if (code.isHave == "N") {
          if (tab == '1') {
            this.getProductPromoCode(1,code.productPromoId)
            // this.onRefresh(1);
          } else {
            this.getProductPromoCode(2,code.productPromoId)
            // this.onRefresh(2);
          }
        } else {
          return
        }
      },
      resetParam(){
        this.emptyList = false
        this.viewIndex = 0;
        this.viewSize = 20;
        this.allLoaded=false;
        this.emptyList = false;
        this.drawProductPromoList = [];
        this.exchangeProductPromoList = [];
      },
      getPromoValue(code) {
        var promoValue = '';
        switch (code.type) {
          case 'gift':
            promoValue = '赠品'
            break;
          case 'discount':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              if ((parseInt(code.value, 10) === code.value)==true) {
                promoValue = code.value + '.0'
              } else {
                promoValue = code.value
              }
            }
            break;
          case 'deduct':
            promoValue = code.value
            break;
          case 'special':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              promoValue = code.value
            }
            break;
          default:
            break
        }
        return promoValue
      },
      onRefresh(i) {
        this.resetParam();
        if (i==1) {
          this.getDrawProductPromoList();
        } else if (i==2) {
          this.getExchangeProductPromoList();
        }
      },
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    },
  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-top: 2.5rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 4rem;width: 100%;position: fixed;bottom: 0;background-color: transparent;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 20rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  .coupon_item {
    height: 7rem;
    padding: 0.25rem 0.5rem;
  }

  .coupon_item_isHave p {
    color: #CCCCCC!important;
  }

  .coupon_item_isHave span {
    color: #CCCCCC!important;
  }

  .coupon_item_isHave div {
    color: #CCCCCC!important;
  }

  .coupon_item_isHave button {
    border-color: #CCCCCC!important;
    color: #CCCCCC!important;
  }

  .coupon_item_isHave .coupon_item_date {
    border-top: 1px solid #CCCCCC!important;
  }

  .coupon_item_width {
    width: 1rem!important;
  }

  .coupon_item_date {
    line-height: 1rem;border-top: 1px solid #6547AA;padding-top: 0.4rem;
  }

  .coupon_item_value_space {
    letter-spacing: 1.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/promo/promoCenter.vue